import { render, staticRenderFns } from "./LevelData.vue?vue&type=template&id=2c05b350&scoped=true&"
import script from "./LevelData.vue?vue&type=script&lang=js&"
export * from "./LevelData.vue?vue&type=script&lang=js&"
import style0 from "./LevelData.vue?vue&type=style&index=0&id=2c05b350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c05b350",
  null
  
)

export default component.exports